<template>
  <div class="weather-widget-wrapper">
    <div class="bottom-widget" v-show="!isExpanded">

      <div class="widget-item widget-item--clock widget-item--flat">
        <div class="widget-clock">
          <div class="widget-clock__time">
            {{ time }}
          </div>
          <div class="widget-clock__date">
            {{ date }}
          </div>
          <div class="widget-clock__weekday">
            {{ weekDay }}
          </div>
        </div>
      </div>

      <router-link to="/weather" class="widget-item widget-this-day-weather">
        <div class="weather-day-item" v-if="forecast[0]">
          <div class="forecast__day">
            {{ timestampToDay(forecast[0].dt) }}
          </div>
          <div class="forecast__icon">
            <img :src="`https://openweathermap.org/img/wn/${forecast[0].weather[0].icon}@2x.png`" alt="">
          </div>
          <div class="forecast__weather" style="margin-bottom: 0;">{{ forecast[0].weather[0].description }}</div>
        </div>
        <div v-else>
          loading...
        </div>
      </router-link>

      <div class="widget-item widget-view-bid-areas">
        <a href="/bid-areas">View other BID areas</a>
      </div>
    </div>
  </div>
</template>
<script>
import {getCache, setCache} from "../assets/scripts/cache";
import {getForecastByCoordinates, timestampToDay} from "../assets/scripts/services";
import {days} from "../assets/scripts/consts";


export default {
  data() {
    return {
      forecast: [],
      isExpanded: false,
      time: '',
      date: '',
      weekDay: ''
    }
  },
  created() {
    const cd = new Date();
    this.time = this.zeroPadding(cd.getHours(), 2) + ':' + this.zeroPadding(cd.getMinutes(), 2);
    this.date = `${this.zeroPadding(cd.getMonth()+1, 2)}/${this.zeroPadding(cd.getDate(), 2)}`
    this.weekDay = days[cd.getDay()];

    // Update clock
    setInterval(() => {
      const cd = new Date();
      this.time = this.zeroPadding(cd.getHours(), 2) + ':' + this.zeroPadding(cd.getMinutes(), 2);
      this.date = `${this.zeroPadding(cd.getMonth()+1, 2)}/${this.zeroPadding(cd.getDate(), 2)}`
      this.weekDay = days[cd.getDay()];
    }, 1000);
  },
  async mounted() {

    // Weather
    const cache = getCache('forecast');
    if (cache !== null) {
      this.forecast = cache;
    }
    else {
      this.forecast = await this.getMtEdenForecast();
      setCache('forecast', this.forecast, 10);
    }

    // Update weather every 10 minutes
    setTimeout(() => {
      this.getMtEdenForecast();
    }, 600000);
  },
  methods: {
    zeroPadding(num, digit) {
      let zero = '';
      for(let i = 0; i < digit; i++) {
        zero += '0';
      }
      return (zero + num).slice(-digit);
    },
    async getMtEdenForecast() {
      return await getForecastByCoordinates({lat: -36.8871, lon: 174.7474});
    },
    timestampToDay(timestamp) {
      return timestampToDay(timestamp);
    }
  }
}
</script>

<style lang="scss">

</style>
